<script>
import WaiverModal from '@/components/WaiverModal.vue'

export default {
    name: 'AccountWaivers',
    components: { WaiverModal },
    data() {
        return {
            waiverResources: [],
            waiverViewing: null,
        }
    },
    computed: {
        waiversOutstandingIds() {
            return this.$refs.waiverModal
                ? this.$refs.waiverModal.waiversOutstanding.map((w) => w.id)
                : []
        },
    },
    mounted() {
        this.$nextTick(() => {
            if (this.$refs.waiverModal) {
                this.$refs.waiverModal.$on('waivers', (waivers) => {
                    this.waiverResources = waivers
                })
            }
        })
    }
}
</script>

<template>
    <div>
        <div class="mb-4">
            <h4 class="mb-1">Waivers</h4>
            <p class="text-muted mb-0">Review and sign required waivers before your session.</p>
        </div>

        <b-table-simple responsive v-if="waiverResources.length > 0">
            <b-thead>
                <b-tr>
                    <b-th>Waiver</b-th>
                    <b-th>Status</b-th>
                    <b-th>&nbsp;</b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr v-for="waiver in waiverResources" :key="waiver.id">
                    <b-td :class="{ 'font-weight-bold': waiver.attributes.required }">{{ waiver }}</b-td>
                    <b-td>
                        <b-badge :variant="waiver.attributes.required ? 'warning' : 'secondary'">
                            {{ waiver.attributes.required ? 'Required' : 'Optional' }}
                        </b-badge>
                    </b-td>
                    <b-td class="text-right">
                        <b-button variant="danger" size="sm" v-if="waiversOutstandingIds.includes(waiver.id)" @click="waiverViewing = waiver">Sign</b-button>
                        <b-button variant="outline-secondary" size="sm" v-else @click="waiverViewing = waiver">View</b-button>
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>

        <p v-else class="text-muted text-center py-4">No waivers on file.</p>

        <waiver-modal ref="waiverModal" v-model="waiverViewing" />
    </div>
</template>
